export default "__VITE_ASSET__661697f9__"